var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { Button, InlineNotification } from '@ui';
import { Modal, ModalHeader, ModalBody, ModalFooter } from '@ui/molecules/Modal';
import { TextInput, TextArea } from '@ui/molecules/inputs/form/TextInput';
import { translate } from '@utils/i18n';
import { updateFolder } from '../../services/CustomerFileDropService';
const namespace = 'features.settings.customer_file_drop';
function RenameFolderModal({ folder, isOpen, onClose, onRenamed }) {
    var _a, _b;
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState(null);
    useEffect(() => {
        var _a;
        if (isOpen && folder) {
            setName(folder.name);
            setDescription((_a = folder.description) !== null && _a !== void 0 ? _a : '');
            setError(null);
        }
    }, [isOpen, folder]);
    const trimmedName = name.trim();
    const trimmedDescription = description.trim();
    const originalName = (_a = folder === null || folder === void 0 ? void 0 : folder.name.trim()) !== null && _a !== void 0 ? _a : '';
    const originalDescription = ((_b = folder === null || folder === void 0 ? void 0 : folder.description) !== null && _b !== void 0 ? _b : '').trim();
    const unchanged = trimmedName === originalName && trimmedDescription === originalDescription;
    const handleSubmit = () => __awaiter(this, void 0, void 0, function* () {
        if (!folder || !trimmedName)
            return;
        setIsSubmitting(true);
        setError(null);
        try {
            const updated = yield updateFolder(folder.id, {
                name: trimmedName,
                description: trimmedDescription
            });
            onRenamed(updated);
            onClose();
        }
        catch (_a) {
            setError(translate('folder_rename_error', { namespace }));
        }
        finally {
            setIsSubmitting(false);
        }
    });
    return (React.createElement(Modal, { isOpen: isOpen, onClose: onClose, ariaLabel: translate('rename_folder', { namespace }) },
        React.createElement(ModalHeader, { title: translate('rename_folder', { namespace }), onClose: onClose }),
        React.createElement(ModalBody, null,
            React.createElement("div", { className: "rename-folder-modal__body", "data-testid": "rename-folder-modal" },
                folder ? (React.createElement(TextInput, { id: "customer-file-drop-rename-folder-id", label: translate('column_id', { namespace }), value: String(folder.id), readOnly: true })) : null,
                React.createElement(TextInput, { id: "customer-file-drop-rename-folder-name", label: translate('folder_name_label', { namespace }), value: name, onChange: (e) => setName(e.target.value), placeholder: translate('folder_name_placeholder', { namespace }) }),
                React.createElement(TextArea, { id: "customer-file-drop-rename-folder-description", label: translate('folder_description_label', { namespace }), value: description, onChange: (e) => setDescription(e.target.value), placeholder: translate('folder_description_placeholder', { namespace }), rows: 3 }),
                error ? (React.createElement(InlineNotification, { variant: "error", title: error },
                    React.createElement("span", null, error))) : null)),
        React.createElement(ModalFooter, null,
            React.createElement(Button, { variant: "secondary", onClick: onClose, disabled: isSubmitting }, translate('cancel', { namespace: 'features.commons' })),
            React.createElement(Button, { onClick: () => {
                    handleSubmit().catch(() => undefined);
                }, disabled: isSubmitting || !trimmedName || unchanged, "data-testid": "rename-folder-submit" }, translate('rename_folder_submit', { namespace })))));
}
export default RenameFolderModal;
